<template>
  <div>
    <label :class="classObject">
      <input
        v-model="changeCheckbox"
        :disabled="isDisabled"
        class="d-none ml-sm-2 checkbox-input"
        :name="formName"
        :value="id || title"
        type="checkbox"
      />
      <span
        class="checkbox-label"
        :class="classObject"
      >{{ title }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    defaultChecked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    formName: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false
    };
  },
  computed: {
    isDisabled() {
      if (this.readOnly) {
        return true;
      }
      if (this.checked) {
        return false;
      }
      return this.disabled;
    },
    classObject() {
      return {
        "text-gray04": this.isDisabled && !this.readOnly,
        "read-only": this.readOnly
      };
    },
    changeCheckbox: {
      get() {
        return this.checked;
      },
      set(checked) {
        this.checked = checked;
        if (this.id) {
          this.$emit("change", this.id, checked);
        } else {
          this.$emit("change", this.title, checked);
        }
      }
    }
  },
  created() {
    this.checked = this.defaultChecked;
    if (this.id) {
      this.$emit("change", this.id, this.checked);
    } else {
      this.$emit("change", this.title, this.checked);
    }
  },
  methods: {
    changeCheckboxStatus(checked) {
      this.checked = checked;
      if (this.id) {
        this.$emit("change", this.id, checked);
      } else {
        this.$emit("change", this.title, checked);
      }
    }
  }
};
</script>
<style scoped>
.checkbox-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
}
.checkbox-label::before {
  content: "";
  position: absolute;
  display: block;
  border: 1px solid #DBDEE1;
  box-sizing: border-box;
  border-radius: 3px;
  width: 20px;
  height: 20px;
  top: calc(50% - 10px);
}
.checkbox-label::after {
  content: "";
  position: absolute;
  display: block;
}
.read-only {
  cursor: default !important;
}
@media (min-width: 577px) {
  .checkbox-label {
    padding: 10px 15px 10px 45px;
    border-radius: 4px;
    background-color: #FFFFFF;
    color: #282828;
    border: 1px solid #DBDEE1;
    box-sizing: border-box;
    border-radius: 3px;
  }
  .checkbox-label::before {
    left: 10px;
    background: #FFFFFF;
  }
  .checkbox-label::after {
    width: 6px;
    height: 10px;
    left: 16px;
    top: calc(50% - 8px);
    border-right: 1px solid #FFFFFF;
    border-bottom: 1px solid #FFFFFF;
    transform: rotate(45deg);
  }
  .checkbox-input:checked + .checkbox-label {
    background-color: #65B1FC;
    color: #FFFFFF;
  }
  .checkbox-input:checked + .checkbox-label::after {
    border-right: 1px solid #0080FC;
    border-bottom: 1px solid #0080FC;
  }
}
@media (max-width: 576px) {
  .checkbox-label {
    color: #282828;
    padding: 0px 0px 0px 30px;
  }
  .checkbox-label::before {
    left: 0px;
    background: #FFFFFF;
  }
  .checkbox-label::after {
    width: 6px;
    height: 10px;
    left: 7px;
    top: calc(50% - 8px);
    border-right: 1px solid #FFFFFF;
    border-bottom: 1px solid #FFFFFF;
    transform: rotate(45deg);
  }
  .checkbox-input:checked + .checkbox-label::before {
    background: #0080FC;
  }
}
</style>
